export const WISK_INTERNAL_ROLE_IDS = []

export function filterWiskInternalRoles(roles, user) {
  if (!Array.isArray(roles)) {
    return roles
  }
  if (user?.is_wisk_user) {
    return roles
  }
  return roles.filter(role => role && !WISK_INTERNAL_ROLE_IDS.includes(role.id))
}
